<template lang="pug">
div(v-if="autoAdjusting")
  slot
TransitionGroup(
  v-else
  tag="span",
  name="toggle"
  @before-leave="beforeLeave"
  @after-leave="afterLeave",
)
  slot
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: "TransitionToggle",
  computed: {
    ...mapGetters(['autoAdjusting']),
  },
  methods: {
    beforeLeave(element) {
      element.style.left = `${element.offsetLeft}px`;
    },
    afterLeave(element) {
      element.style.left = ``;
    },
  }
};
</script>

<style scoped lang="scss">
div {
  display: contents;
}

span {
  display: contents;

  &::v-deep {
    &>* {
      transition-property: all;
      transition-duration: 0.35s;
      transition-timing-function: ease;
    }

    .toggle-enter,
    .toggle-leave-to {
      opacity: 0;
    }

    .toggle-leave-active {
      position: absolute;
    }
  }
}
</style>
